import {
  Checkbox as ChakraCheckbox,
  CheckboxProps as ChakraCheckboxProps,
  FormErrorMessageProps,
} from '@chakra-ui/react';
import { ComponentStyleConfig } from '@chakra-ui/theme';
import { FormErrorMessage } from 'components/UI/forms';

const CheckboxStyles: ComponentStyleConfig = {
  baseStyle: {
    control: {
      _checked: {
        bg: 'primaryThemeColour.400',
        borderColor: 'primaryThemeColour.400',
        _hover: {
          bg: 'primaryThemeColour.400',
          borderColor: 'primaryThemeColour.400',
        },
      },
      _focus: {
        boxShadow: 'none',
        borderColor: 'primaryThemeColour.400',
      },
    },
  },
  variants: {
    white: {
      control: {
        bg: 'white',
        _disabled: {
          bg: 'gray.200',
        },
      },
    },
  },
};

type CheckboxProps = ChakraCheckboxProps & {
  error?: string;
  errorProps?: FormErrorMessageProps;
};

const Checkbox = ({ errorProps, error, ...props }: CheckboxProps) => (
  <>
    <ChakraCheckbox {...props} />
    <FormErrorMessage {...errorProps}>{error}</FormErrorMessage>
  </>
);

export { Checkbox, CheckboxStyles };
